<template>
  <div>
    <Edit
      :item="currentItem"
      :close="closeEdit"
      :onSubmit="onSubmit"
      :sistemasDisponiveis="sistemas"
      :iconesDisponiveis="iconesDisponiveis"
    />
    <CTabs variant="tabs" class="nav-tabs-boxed">
      <CTab title="VITRINES">
        <div class="row">
          <div class="col-12 text-right header-buttons">
            <CButton color="primary" @click="openCreate" size="sm">
              Novo registro
            </CButton>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <table-paginated
              :itens="vitrines"
              :columns="columns"
              :paginator="paginator"
              :onPageChange="() => {}"
              :onDelete="onWillDelete"
              :onUpdate="onWillUpdate"
              :isLoadingData="loading"
            >
              <template v-slot:cor="{model}">
                <div
                  style="width: 15px; height: 15px; border-radius: 3px"
                  :style="{ 'background-color': model.cor }"
                ></div>
              </template>

              <template v-slot:tipo_regra="{model}">
                <span class="badge" :class="tipoRegraBadge(model.tipo_regra)">
                  {{ tipoRegraLabel(model.tipo_regra) }}
                </span>
              </template>

              <template v-slot:action-buttons-after="{model}">
                <CButton
                  v-if="model.tipo_regra !== 'manual'"
                  size="sm"
                  color="info"
                  @click="syncVitrine(model)"
                  title="Sincronizar produtos"
                  :disabled="syncing"
                >
                  <fa-icon icon="sync" />
                </CButton>
              </template>
            </table-paginated>
          </div>
        </div>
      </CTab>
    </CTabs>
  </div>
</template>

<script>
import clone from "just-clone";
import { get, post, put } from "@/helpers/apiRequest";
import { confirmDelete, confirmStore, confirmUpdate, alertOnSuccess, alertOnError } from "@/helpers/crud";
import { yesNoRepresentation } from "@/helpers/transformers";
import TablePaginated from "@/components/crud/TablePaginated";
import Edit from "./Edit";

const initialItem = {
  id: "",
  label: "",
  titulo: "",
  descricao: "",
  cor: "#000",
  tag_produto: "",
  ativo: true,
  home: true,
  ordem: 0,
  coluna: "",
  valor: 1,
  tipo_regra: "fixa",
  tagsFiltro: [],
  banco: "LOCAL",
  sql: "",
  produtos: [],
  sistemas: [],
  imagem_desktop: "",
  imagem_mobile: "",
  icone: "",
  exibe_titulo: false,
  exibe_descricao: false,
  destacar_produto: false,
};

const tipoRegraLabels = {
  fixa: "Regra Fixa",
  manual: "Manual",
  tag_filtro: "Tag Filtro",
  sql: "SQL",
};

const tipoRegraBadges = {
  fixa: "badge-primary",
  manual: "badge-success",
  tag_filtro: "badge-warning",
  sql: "badge-info",
};

export default {
  name: "vitrines",
  components: {
    Edit,
    TablePaginated,
  },
  props: ["sistemas"],
  data() {
    return {
      vitrines: [],
      loading: false,
      syncing: false,
      currentItem: {},
      iconesDisponiveis: [],
      paginator: {},
      columns: [
        { label: "Titulo", field: "titulo", sortable: false },
        { label: "Cor", field: "cor", sortable: false, useSlot: true },
        { label: "Ordem", field: "ordem", sortable: false },
        { label: "Tipo Regra", field: "tipo_regra", sortable: false, useSlot: true },
        { label: "Exibir na Home", field: "home", sortable: false, representedAs: (row) => yesNoRepresentation(row.home) },
        { label: "Ativo", field: "ativo", sortable: false, representedAs: (row) => yesNoRepresentation(row.ativo) },
      ],
    };
  },
  methods: {
    loadVitrines() {
      this.loading = true;
      get("/admin/marketing/vitrines")
        .then((json) => {
          this.vitrines = json;
          this.loading = false;
          this.$emit("vitrines-loaded", json);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    openCreate() {
      this.currentItem = clone(initialItem);
      this.$modal.show("vitrineEdit");
    },
    onWillUpdate(row) {
      const data = { ...clone(initialItem), ...clone(row) };
      if (data.banco) data.banco = data.banco.toUpperCase();
      this.currentItem = data;
      this.$modal.show("vitrineEdit");
    },
    onWillDelete(row) {
      confirmDelete(`/admin/marketing/vitrines/${row.id}`, this.loadVitrines);
    },
    closeEdit() {
      this.currentItem = clone(initialItem);
      this.$modal.hide("vitrineEdit");
    },
    onSubmit(item) {
      const onSuccess = () => {
        this.closeEdit();
        this.loadVitrines();
      };

      if (item.id) {
        return confirmUpdate(`/admin/marketing/vitrines/${item.id}`, item, onSuccess);
      }
      return confirmStore("/admin/marketing/vitrines", item, onSuccess);
    },
    syncVitrine(row) {
      this.syncing = true;
      post(`/admin/marketing/vitrines/${row.id}/sync`)
        .then((json) => {
          this.syncing = false;
          this.loadVitrines();
          alertOnSuccess(json.message || "Vitrine sincronizada com sucesso!");
        })
        .catch((error) => {
          this.syncing = false;
          alertOnError(error.message || "Falha ao sincronizar vitrine.");
        });
    },
    loadIcones() {
      get("/admin/marketing/vitrines/icones")
        .then((json) => {
          this.iconesDisponiveis = json;
        })
        .catch(() => {});
    },
    tipoRegraLabel(tipo) {
      return tipoRegraLabels[tipo] || tipo;
    },
    tipoRegraBadge(tipo) {
      return tipoRegraBadges[tipo] || "badge-secondary";
    },
  },
  beforeMount() {
    this.loadVitrines();
    this.loadIcones();
  },
};
</script>

<style scoped>
.header-buttons {
  margin-bottom: 10px;
}

.header-buttons button {
  margin-left: 5px;
}
</style>
